/**
 * A button at the end of a form field — the F2 "letzte Werte" button — drawn
 * the way MUI draws its own Autocomplete indicators, the clear X and the popup
 * arrow: 4px padding round a small icon, pulled 2px to the right. Side by side
 * with the X it then reads as one more indicator rather than a stranger in the
 * row.
 */
export const FIELD_END_BUTTON_SX = { padding: '4px', marginRight: '-2px' };

/** The width MUI reckons per indicator when it keeps room for them. */
const INDICATOR_WIDTH = 26;

/**
 * Room at the end of an Autocomplete's input for `count` indicators, so typed
 * text stops before them instead of running underneath.
 *
 * MUI keeps this room only for the indicators it draws itself (see its
 * `hasClearIcon`/`hasPopupIcon` padding), so one we add has to be paid for here.
 * Same sum as MUI's: the indicators, 4px, and the 9px the indicator box sits
 * in from the edge. `&&&` outranks MUI's own rule for the same padding.
 */
export function indicatorRoomSx(count: number) {
    return {
        '&&& .MuiAutocomplete-inputRoot': {
            paddingRight: `${INDICATOR_WIDTH * count + 4 + 9}px`
        }
    };
}
